import { useRef } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import "./anyone.css";

/* Situations, not stages — and deliberately mixed so the page never reads
   as student-only. Each card ends with the first few things RAIN would
   actually put on your list in that situation. */
const situations = [
  {
    title: "Still figuring it out",
    body:
      "You don’t know what you want yet. Start from what you’re curious about and let the search narrow itself down.",
    tasks: [
      "Pick three fields worth a closer look",
      "Talk to someone in each one",
      "Rule two of them out",
    ],
  },
  {
    title: "First internship",
    body:
      "No experience, no network, no idea where to start. RAIN gives you the first few things to do, in order.",
    tasks: [
      "Draft your resume bullets",
      "Reach out to two alumni",
      "Apply to three roles this week",
    ],
  },
  {
    title: "Full-time search",
    body:
      "Graduation is coming and the deadlines are stacking up. RAIN puts every application, follow-up, and interview in order so nothing slips.",
    tasks: [
      "Follow up on last week’s applications",
      "Prep for Thursday’s first round",
      "Thank the two people who referred you",
    ],
  },
  {
    title: "Changing fields",
    body:
      "You have experience, just not in the field you want next. RAIN maps the gap and who can help you close it.",
    tasks: [
      "Reframe your experience for the new field",
      "Find five people who made the jump",
      "Ask each of them one question",
    ],
  },
  {
    title: "Looking while working",
    body:
      "You already have a job and no spare hours. Short weekly plans that fit in the time you actually have.",
    tasks: [
      "Send two outreach notes by Friday",
      "Schedule one call at lunch",
      "Update your resume once",
    ],
  },
  {
    title: "Picking it back up",
    body:
      "A gap, a layoff, a break. Restart the search from where you left off instead of from nothing.",
    tasks: [
      "Reconnect with three contacts",
      "Update your resume with what’s changed",
      "Send one application to get moving",
    ],
  },
];


const Anyone = () => {
  const trackRef = useRef(null);

  const scrollBy = (direction) => {
    const track = trackRef.current;
    if (!track) return;
    const card = track.querySelector(".s-any-card");
    const step = card ? card.getBoundingClientRect().width + 20 : 340;
    track.scrollBy({ left: step * direction, behavior: "smooth" });
  };

  return (
    <section className="s-section s-any">
      <div className="home-container">
        <h2 className="home-section-title s-any-title">
          Use RAIN for your first internship, your
          <br />
          next move, and everything in between.
        </h2>

        <div className="s-any-controls">
          <button type="button" onClick={() => scrollBy(-1)} aria-label="Previous">
            <ArrowLeft size={18} strokeWidth={2} />
          </button>
          <button type="button" onClick={() => scrollBy(1)} aria-label="Next">
            <ArrowRight size={18} strokeWidth={2} />
          </button>
        </div>
      </div>

      <div className="s-any-track" ref={trackRef}>
        {situations.map(({ title, body, tasks }) => (
          <article className="s-any-card" key={title}>
            <h3 className="s-any-card-title">{title}</h3>
            <p className="s-any-card-body">{body}</p>

            {/* Bleeds off the bottom edge, the way the reference's
                product snippets do. */}
            <div className="s-any-list">
              <p className="s-any-list-label">Your first week</p>
              {tasks.map((task) => (
                <p className="s-any-task" key={task}>
                  <span className="s-any-box" aria-hidden="true" />
                  {task}
                </p>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Anyone;
